/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import React, { useCache, withMemo, useFlux } from 'fierry/react.old';

import Navigation from 'shared/client/navigation';
import Zoom from 'astro/client/zoom';
import Grid from 'astro/client/map/grid.local';

import Entity from 'astro/react/map/entity';
import Zone from 'astro/react/map/zone';
import Dock from 'astro/react/map/dock';
import Platform from 'astro/react/map/platform';

import Center from 'astro/react/map/zone/center';
import Unit from 'astro/react/map/entity/unit';


const Zones = ({ planet, navigation, ...props }) =>
{
  let collection = [];

  for (const zone of planet.getZones().getAll())
  {
    if (zone.isPlatform())
    {
      collection.push(<Platform {...props} key = {zone.getLocation().getID()} location = {zone.getLocation()} {...navigation.getLocationInfo(zone.getLocation())} />);
    }
    else
    {
      collection.push(<Zone {...props} key = {zone.getID()} zone = {zone} {...navigation.getLocationInfo(zone.getLocation())} />);
    }
  }

  for (const sector of planet.getSectors().getAll())
  {
    for (const dock of sector.getNeighbors().getDocks())
    {
      collection.push(<Dock {...props} key = {dock.getLocation().getID()} location = {dock.getLocation()} {...navigation.getLocationInfo(dock.getLocation())} />);
    }
  }

  return collection;
}


const Entities = ({ planet, ...props }) =>
{
  if (!props.grid.getZoom().isEntityVisible())
  {
    return null;
  }

  let collection = [];

  for (const zone of planet.getZones().getAll())
  {
    if (!zone.isPlatform())
    {
      collection.push(<Entity {...props} key = {zone.getID()} zone = {zone} />);
    }
    else if (zone.getEntity())
    {
      const location = zone.getLocation();

      collection.push(<Entity {...props} key = {zone.getID()} zone = {zone} />);

      //collection.push(<Center key = {zone.getID()} local {...props} location = {location} > <Building {...props} location = {location} zone = {zone} /> </Center>);
    }
  }

  return collection;
}


const Component = (props) =>
(
  <>
    <Zones {...props} />
    <Entities {...props} />
  </>
);


export default withMemo(({ currentUserID, ...props }) =>
{
  const [ navigation, zoom ] = useFlux(Navigation, Zoom);

  const grid = useCache(() => new Grid(zoom), [zoom, props.planet]);

  return <Component {...props} grid = {grid} navigation = {navigation} currentUser = {props.planet.getUser(currentUserID)} />;
});
